module.exports = __webpack_public_path__ + "static/media/photo36.856e76d0.jpg";